import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { actionBoundaryConfigSchema } from "../../utils/action-interfaces";

export const actionOutputStep = defineStepConfig({
  type: "action_output",
  name: "Action Output",
  description:
    "Exit point for reusable workflow actions. Input sockets are derived from connected upstream outputs.",
  category: "Utility",
  inputSchema: z.record(z.string(), z.unknown()),
  outputSchema: z.record(z.string(), z.unknown()),
  configSchema: actionBoundaryConfigSchema,
  emits: [] as const,
});
